{
  "internalRepair": {
    "country": "Country",
    "operatingCenter": "Operating centre",
    "finalizationSubtitle": "Finalize your internal repair without arranging transport.",
    "documentsSubtitle": "Download the repair order and supporting documents for your internal repair.",
    "documentsTitle": "Repair order and supporting documents",
    "download": "Download the repair order",
    "finalize": "Finalize the dossier",
    "confirmation": "Confirm creation of your internal repair dossier."
  },
  "prospect": {
    "title": "Preliminary request",
    "subtitle": "Complete the client details, send your request and validate the manufacturer's response.",
    "stages": {
      "client": "Client information",
      "request": "Preliminary support request",
      "response": "Manufacturer response to the support request"
    },
    "normalOption": "OPTION 1: All brands, I do not know the process; I request coverage from the manufacturer",
    "expertOption": "OPTION 2: PRAMAC, RUBI, ABAC and LECIA only; EXPERT process, I select the repairer directly",
    "privacy": "Client details are used to process this repair request and contact the client.",
    "pictureTitle": "Add the requested pictures to complete the file",
    "pictureHint": "Choose an upload method below",
    "pictureNumber": "Picture-{count}",
    "referenceImage": "Reference pictures for the preliminary request",
    "documentTitle": "Add supporting documents to the file",
    "documentNumber": "Document-{count}",
    "moreInfo": "Provide details to help process the request",
    "moreInfoHint": "Exact model, supplier reference, size, colour and any other useful details",
    "moreInfoPlaceholder": "Example: the zipper has torn all the seams",
    "acknowledge": "I have included all this information",
    "validateRequest": "Validate the preliminary request",
    "send": "Send to the repairer",
    "sendTitle": "Preliminary support request to the repairer",
    "sendInformation": "All documents and comments will be sent to the repairer for a complete diagnosis.",
    "previewPdf": "Support request",
    "repairerEmail": "Send the request to the repairer by email",
    "repairerEmailPlaceholder": "Repairer email address",
    "sendNotice": "The file will be saved while awaiting the repairer's response.",
    "waiting": "Request sent. Awaiting the manufacturer's response. You can also enter a response received directly.",
    "expertSummary": "Expert process — no manufacturer request sent.",
    "responseReceived": "Check and validate the manufacturer's response before continuing.",
    "refresh": "Refresh response",
    "refreshTitle": "Refresh the manufacturer's response?",
    "refreshMessage": "Your unsaved response changes will be replaced by the saved response.",
    "supportNumber": "Support request number",
    "supportNumberPlaceholder": "Enter the support request number",
    "comment": "Comment",
    "commentPlaceholder": "Describe the manufacturer's response and any useful instructions for the store",
    "responseAttachment": "Add an attachment",
    "manufacturerDecision": "Manufacturer decision",
    "confirmResponse": "Confirm the manufacturer's response",
    "confirmResponseMessage": "Confirmation triggers actions on the file and cannot be undone.",
    "retryContinuation": "Use Continue to reload the saved result without submitting the decision again.",
    "unavailable": "This prospect stage is not editable. Reopen the file to refresh its state.",
    "mobileHint": "Upload your files, then confirm the upload on your computer.",
    "imageFormats": "JPG, JPEG or PNG",
    "anyFormat": "Any document format",
    "choices": {
      "PRODUCT_REPAIR_WITHOUT_GUARANTEE": "Return the product for diagnosis",
      "TECHNICIAN_ON_SITE_INTERVENTION": "On-site technician intervention",
      "CREDIT_OR_REFUND": "Credit / refund",
      "PRODUCT_REPLACEMENT": "Replace with a new product",
      "REJECT_PROSPECT": "Reject repair and close the file",
      "OTHER": "Other"
    }
  },
  "search": "Search a repair file",
  "list": {
    "title": "Repair files",
    "subtitle": "Track repair files linked to your operating center.",
    "newRepairFile": "New repair file"
  },
  "storeOriginWarning": {
    "title": "This repair file was initiated by your distributor on your behalf.",
    "message": "Please confirm that you have read this information before opening the repair file.",
    "checkbox": "I have read this information.",
    "confirm": "Open repair file"
  },
  "shipping": {
    "title": "Shipping",
    "subtitle": "Prepare and generate the repair-file shipment",
    "backToTransport": "Back to transport options",
    "transporter": {
      "chronopost": "Chronopost",
      "subtitle": "Express pickup with automatic label"
    },
    "departure": "Departure",
    "delivery": "Delivery",
    "package": "Package",
    "constraints": "Chronopost constraints",
    "summaryInProgress": "Repair file shipment in progress",
    "address": "Address",
    "city": "City",
    "departureSubtitle": "Pickup address",
    "deliverySubtitle": "Repairer address",
    "constraintsSubtitle": "Pickup date and time window",
    "collectTitle": "Generate a label without pickup",
    "collectSubtitle": "Generate the shipping label without scheduling a pickup.",
    "earliestPickupTime": "Earliest pickup time",
    "latestPickupTime": "Latest pickup time",
    "shipmentCreationDeadline": "Shipment creation deadline",
    "pickupDate": "Pickup date",
    "weight": "Weight",
    "width": "Width",
    "length": "Length",
    "checkFeasibility": "Check pickup availability",
    "generateShipment": "Generate shipment",
    "message": {
      "feasibilitySuccess": "Chronopost pickup is available.",
      "generateSuccess": "Chronopost shipment created.",
      "missingService": "No Chronopost shipping service is available.",
      "invalidConstraints": "Chronopost constraints do not allow this shipment to be scheduled.",
      "invalidCollection": "The pickup date or time is no longer valid. Refresh the constraints and choose another pickup date.",
      "chronopostError": "Chronopost could not process the request. Please try again.",
      "loadError": "Unable to load shipping information."
    }
  },
  "customerServiceTransport": {
    "title": "Customer service transport request",
    "subtitle": "Enter the information needed to arrange pickup",
    "back": "Back to transport options",
    "retry": "Try again",
    "submit": "Send request",
    "summary": "Transport request in preparation",
    "transportTitle": "Transport arranged by repairer customer service",
    "transportSubtitle": "The repairer will use this information to arrange pickup and send you the transport documents.",
    "steps": {
      "step1": {
        "title": "Pickup location and details",
        "subtitle": "Select the location and check the contact and address."
      },
      "step2": {
        "title": "Package information",
        "subtitle": "Check the package dimensions and packaging."
      },
      "step3": {
        "title": "Pickup availability",
        "subtitle": "Enter the available days and time slots."
      }
    },
    "location": {
      "title": "Pickup location",
      "subtitle": "Select the location",
      "customer": "At the customer",
      "site": "At the operating center"
    },
    "contact": {
      "title": "Pickup contact and address",
      "subtitle": "These details remain editable for this request only.",
      "lastname": "Last name",
      "firstname": "First name",
      "email": "Email",
      "phone": "Phone",
      "addressName": "Site name",
      "addressNumber": "No.",
      "addressStreet": "Street",
      "addressComplement1": "Address complement 1",
      "addressComplement2": "Address complement 2",
      "zipCode": "Zip code",
      "city": "City",
      "country": "Country"
    },
    "package": {
      "title": "Package information",
      "subtitle": "Enter the characteristics of the package ready for pickup.",
      "weight": "Weight (kg)",
      "length": "Length (cm)",
      "width": "Width (cm)",
      "height": "Height (cm)",
      "pallet": "Transport on a pallet"
    },
    "comment": {
      "label": "Transport comment",
      "placeholder": "Specify the preferred pickup day(s), instructions for the driver, the specific product location..."
    },
    "planning": {
      "removeSlot": "Remove slot",
      "days": {
        "monday": "Monday",
        "tuesday": "Tuesday",
        "wednesday": "Wednesday",
        "thursday": "Thursday",
        "friday": "Friday"
      },
      "errors": {
        "invalidRange": "The end time must be later than the start time.",
        "overlap": "Time slots cannot overlap.",
        "tooManySlots": "A maximum of two slots is allowed per day."
      }
    },
    "recipient": {
      "title": "Recipient customer service",
      "email": "Repairer email address",
      "phone": "Customer service phone",
      "customerNumber": "Your repairer customer number"
    },
    "documents": {
      "title": "Documents",
      "customerServiceForm": "Customer after-sales service form",
      "order": "Repair order"
    },
    "summarySections": {
      "location": "Pickup",
      "pickupLocation": "Location",
      "contact": "Contact",
      "address": "Address",
      "city": "City",
      "package": "Package",
      "dimensions": "Dimensions (L x W x H)",
      "comment": "Comment"
    },
    "message": {
      "loadError": "Transport information could not be loaded. Try again before sending the request.",
      "success": "Transport request sent"
    }
  },
  "finalization": {
    "title": "Finalization of repair file No. {number}",
    "subtitle": "Follow the 3 mandatory steps below to activate tracking for your repair. None can be skipped.",
    "subtitleWithoutTracking": "Follow the 3 steps below to activate tracking for your repair.",
    "required": "Required",
    "repairerNumber": "Repairer number",
    "repairerNumberPlaceholder": "Enter the number",
    "download": "Download",
    "redownload": "Re-download",
    "trackingNumber": "Tracking number",
    "trackingNumberPlaceholder": "XR123456789FR",
    "shareWithClient": "Client",
    "clientEmail": "Client email address",
    "shareWithLogisticsContact": "Logistics coordinator",
    "logisticsContactEmail": "Logistics coordinator email address",
    "shareWithSales": "Sales team",
    "salesEmail": "Sales contact email address",
    "finishLater": "Finish later",
    "activateTracking": "Activate repair-file tracking",
    "sections": {
      "transportDetails": "Enter transport information",
      "documents": "Print the documents for the repairer",
      "documentsSubtitle": "These documents must be placed inside the parcel. Without them, your product cannot be handled or repaired by the technician.",
      "activateTracking": "Activate repair-file tracking",
      "activateTrackingSubtitle": "By confirming, you declare that you have entered the tracking number and placed all documents inside the parcel. Tracking for your repair will then be activated.",
      "activateWithoutTrackingSubtitle": "By confirming, you declare that you have placed all documents inside the parcel. Tracking for your repair will then be activated."
    },
    "documentsIncluded": {
      "repairOrder": "Repair order",
      "guaranteeExtensionProof": "Guarantee extension proof",
      "purchaseProof": "Purchase proof",
      "asbestosProof": "Asbestos proof",
      "forceSupportProof": "Forced support proof",
      "batteryLabel": "Battery label",
      "transportLabel": "Transport label",
      "transporterRepairerDocument": "Transporter document for the repairer"
    },
    "documentPlacements": {
      "stickOnParcel": "Stick on the parcel",
      "putInParcel": "Put inside the parcel"
    },
    "message": {
      "trackingRequired": "A tracking number is required",
      "downloadRequired": "Download the repair-file documents before finalizing",
      "success": "Repair file finalized"
    }
  },
  "create": {
    "title": "Repair file in creation",
    "continue": "Continue",
    "quit": "Quit",
    "loadError": "The repair file could not be loaded.",
    "quitModal": {
      "title": "Quit repair file creation?",
      "message": "This draft repair file will be deleted. This action cannot be undone.",
      "validate": "Delete draft",
      "cancel": "Continue creation"
    },
    "leaveModal": {
      "title": "You are leaving this repair file",
      "subtitle": "Choose whether to resume this repair file later or abandon it.",
      "reasonTitle": "What is the reason?",
      "reasonSubtitle": "The repair file will appear in the table with the Abandoned status.",
      "stepOne": "1/2",
      "stepTwo": "2/2",
      "saveAndLeave": "Resume repair file creation later",
      "abandon": "Abandon repair file",
      "confirmAbandon": "Abandon repair file",
      "recycle": "Offer recycling/buyback solution",
      "recyclingTitle": "Recycling/buyback solution",
      "abandonHelp": "Abandoning closes the repair file with the selected reason.",
      "detail": "Reason details",
      "reasons": {
        "deadlineTooLong": "Deadline too long",
        "noPackage": "No package",
        "other": "Other",
        "repairTooExpensive": "Package too expensive, no immediate purchase",
        "repairTooExpensiveBuyCommon": "Repair too expensive, buying a product from the ",
        "buySameBrand": "same brand",
        "buyOtherBrand": "another brand",
        "repairTooExpensiveBuySame": "Repair too expensive, buying a product from the same brand",
        "repairTooExpensiveBuyOther": "Repair too expensive, buying a product from another brand"
      }
    },
    "subtitles": {
      "product": "Select the affected product",
      "breakdown": "Describe the breakdown reason",
      "guarantee": "Evaluate guarantee coverage",
      "pricing": "Select matching pricing",
      "clientInfo": "Fill customer information",
      "transport": "Configure transport"
    },
    "stepper": {
      "ariaLabel": "Repair file creation steps"
    },
    "steps": {
      "product": "Product",
      "breakdown": "Breakdown reason",
      "guarantee": "Guarantee evaluation",
      "pricing": "Pricing",
      "clientInfo": "Customer information",
      "transport": "Transport"
    },
    "clientInfo": {
      "title": "Customer information",
      "subtitle": "Check the contact details used to create the file. Fields are prefilled from your account and operating center.",
      "company": "Company name",
      "companyPlaceholder": "Company name",
      "worksiteCode": "Allocation code",
      "worksitePlaceholder": "Worksite code, internal code, cost center...",
      "worksiteMax": "Code must contain 25 characters maximum",
      "worksiteFormat": "Use only uppercase letters, numbers and spaces",
      "lastname": "Last name / first name",
      "lastnamePlaceholder": "Contact name",
      "email": "Email",
      "emailPlaceholder": "Contact email",
      "phone": "Phone",
      "phonePlaceholder": "Phone"
    },
    "transport": {
      "addressesTitle": "Address information",
      "addressSubtitle": "Select a transport mode and confirm the departure and return addresses.",
      "choiceTitle": "Transport selection",
      "choiceSubtitle": "Select the equipment and a transport option.",
      "modeLabel": "Transport mode",
      "modePlaceholder": "Select a mode",
      "addressSectionTitle": "Enter the addresses",
      "addressFlow": {
        "departure": "Departure",
        "repair": "Repair",
        "return": "Return"
      },
      "sendToRepairer": "Send to manufacturer/repairer",
      "distributorDropOff": "Product drop-off at a distributor",
      "departureAddress": "Departure address",
      "repairAddress": "Repairer",
      "returnAddress": "Return address",
      "addressName": "Address name",
      "address": "Address",
      "addressNumber": "No.",
      "addressStreet": "Street",
      "addressLine2": "Address line 2",
      "zipCode": "Zip code",
      "city": "Zip code City",
      "contact": "Contact name",
      "email": "Email",
      "phone": "Phone",
      "editAddress": "Edit address",
      "editDepartureAddress": "Edit departure address",
      "editReturnAddress": "Edit return address",
      "saveAddress": "Save address",
      "scheduleShipment": "Schedule shipment",
      "confirmAddress": "Confirm information",
      "material": "Material to declare",
      "materialSubtitle": "Pre-selected based on the declared breakdown. Adjust quantities if needed.",
      "package": "Package details (automatic calculation)",
      "packetWeight": "Weight",
      "packetLength": "Length (cm)",
      "packetWidth": "Width (cm)",
      "battery": "Battery",
      "pallet": "Pallet",
      "transporterChoiceTitle": "Choose the transporter",
      "transporterChoiceSubtitle": "Available options depend on the declared material and package dimensions.",
      "materialLoadError": "The material to declare could not be loaded.",
      "chronopostLoadError": "Chronopost is temporarily unavailable. Other transport options remain available.",
      "routingDiagnostic": {
        "title": "No official repairer configuration matches this repair file.",
        "fields": {
          "manufacturer": "Manufacturer",
          "category": "Category",
          "subcategory": "Subcategory",
          "store": "Store",
          "warranty": "Warranty support"
        },
        "warranty": {
          "without_guarantee": "Non-warranty",
          "guarantee": "Under warranty"
        },
        "candidates": "Closest configurations in the selected store's network (an administrator must confirm the intended repairer):",
        "missing": "unmet conditions: {conditions}.",
        "limit": "Only the first 5 of {count} closest configurations are displayed.",
        "noCandidates": "No configuration associated with this manufacturer, category or subcategory was found in the selected store's network.",
        "noConfiguration": "No repairer configuration exists for the selected store's network.",
        "action": "An administrator must confirm the intended repairer and correct its associations or warranty support. Exactly one configuration must satisfy all conditions above. No repairer has been selected automatically."
      },
      "whitelistLoadError": "The repairer's transport configuration could not be verified. Try again before requesting repairer-arranged transport.",
      "choiceCards": {
        "immediateSubtitle": "Chronopost pickup and tracking",
        "specificTitle": "Specific transport (freight)",
        "specificSubtitle": "Use this option when Chronopost cannot handle the shipment, for example because of non-standard dimensions.",
        "withoutTitle": "Arrange transport independently",
        "withoutSubtitle": "No logistics tracking by the Boomerang team."
      },
      "batteryModal": {
        "title": "Battery specifications",
        "message": "Damaged lithium batteries can short-circuit during transport, causing overheating or fire.\n\nThe shipper is responsible for the transport and any resulting costs in the event of an accident. Dangerous goods must be correctly declared, packed, labeled, and accompanied by the required documentation.\n\nBatteries rated at 100 Wh or more are not accepted by express carriers (TNT, Chronopost, or UPS). They must be sent by freight transport and declared and labeled accordingly. The label is available at the end of this process.",
        "voltage": "Battery voltage",
        "amperage": "Battery current",
        "voltagePlaceholder": "18 V",
        "amperagePlaceholder": "8 Ah",
        "expressYes": "Express transport allowed",
        "expressNo": "Freight transport required",
        "checkbox": "Special cases:\nDEWALT: I confirm that I installed the required cover on the FLEXVOLT battery so it can be sent by express transport.\nFESTOOL: I confirm that I switched the POWERSTATION to OFF so it can be sent by express transport.",
        "save": "Save"
      },
      "specificTransportModal": {
        "title": "Request repairer-arranged transport",
        "customerServiceForm": "Customer service form",
        "orderDocument": "Repair order",
        "repairerEmail": "Repairer email address",
        "emailPlaceholder": "repairer{'@'}example.com",
        "infoTitle": "Additional information",
        "repairerCustomerServicePhone": "Repairer customer service phone",
        "repairerCustomerNumber": "Your repairer customer number",
        "internalOrderNumber": "Your internal order number",
        "sendRequest": "Send request",
        "pendingLabelMessage": "The repair file will be saved while you wait for the shipping label.",
        "partnerProcessingMessage": "The repairer will process your request and send you the shipping label.",
        "alert": "If you have not received a response within 48 hours, contact the {team}.",
        "teamLabel": "Boomerang team",
        "success": "Transport request sent"
      }
    },
    "product": {
      "popular": "Most popular products",
      "selectProduct": "Select the product",
      "manufacturerLabel": "What is the product brand?",
      "categoryLabel": "What is the product range?",
      "subCategoryLabel": "What is the product sub-range?",
      "manufacturerPlaceholder": "Select brand",
      "categoryPlaceholder": "Select range",
      "subCategoryPlaceholder": "Select sub-range",
      "noProduct": "No product",
      "notRepairable": "Not repairable",
      "loadError": "Products could not be loaded.",
      "retry": "Retry",
      "requestMissing": "Can't find your product?",
      "requestAdd": "Request addition",
      "requestModal": {
        "title": "Request product creation",
        "message": "Add the details visible on the nameplate. Response within 8 to 24h.",
        "manufacturer": "Brand",
        "productName": "Product name",
        "productCode": "Product code / reference",
        "email": "Contact email",
        "senderName": "Your client's company name (to resume the file later)",
        "underGuarantee": "Under warranty",
        "nameplate": "Nameplate",
        "dropzoneTitle": "Drop the nameplate photo",
        "acceptedFormats": "Accepted formats: JPG, PNG, WEBP, HEIC",
        "nameplateHint": "Nameplate photo. If there is no nameplate, add a photo of the full product.",
        "takePhoto": "Take a photo",
        "removeFile": "Remove photo",
        "openQr": "Add with QR code",
        "qrSubtitle": "Scan this QR code to take a photo of the nameplate. Tick the checkbox once this step is complete.",
        "qrValidated": "I confirm I added the photo with QR code",
        "qrValidationError": "No photo has been added with QR code yet.",
        "qrUploaded": "Photo added with QR code.",
        "submit": "Send request (response within 8-24h)",
        "cancel": "Cancel",
        "successMessage": "Your product creation request has been sent."
      },
      "asbestosModal": {
        "title": "Asbestos declaration",
        "message": "Has product {productName} been exposed to asbestos? If yes, you can add the asbestos certificate now or provide it later.",
        "continue": "Continue",
        "cancel": "Cancel",
        "dropzoneTitle": "Drop the asbestos certificate",
        "acceptedFormats": "Accepted formats: PDF, JPG, PNG",
        "addFile": "Add certificate",
        "removeFile": "Remove certificate"
      }
    },
    "breakdown": {
      "title": "Describe the breakdown",
      "subtitle": "Describe the observed issue. Best guarantee coverage will be computed next.",
      "descriptionLabel": "What problem do you see?",
      "descriptionPlaceholder": "Briefly describe the observed issue",
      "typeLabel": "Breakdown type",
      "typePlaceholder": "Select breakdown type",
      "notFoundBreakdown": "I cannot find the breakdown type",
      "loadError": "Breakdown information could not be loaded.",
      "questionModal": {
        "title": "Questions - {breakdown}",
        "message": "Answer the questions linked to the selected breakdown type."
      },
      "productType": {
        "MACHINE": "Machine",
        "BATTERY": "Battery",
        "CHARGER": "Charger",
        "PRODUCT": "Product",
        "ACCESSORY_ONE": "Accessory 1",
        "ACCESSORY_TWO": "Accessory 2",
        "BRIEFCASE": "Briefcase",
        "PREMIUM_CONSUMABLE": "Premium consumable",
        "PPE": "Personal protective equipment",
        "EQUIPMENT": "Equipment",
        "SUB_PRODUCT": "Sub-product",
        "PALLET": "Pallet"
      }
    },
    "pricing": {
      "title": "Choose repair store",
      "subtitle": "Compare available suggestions. Selecting one moves the repair file into that store scope.",
      "externalRate": "External rate",
      "internalRepair": "Internal repair",
      "internalRate": "Internal rate",
      "package": "Package",
      "estimate": "Estimate",
      "free": "Free",
      "packagePricePrefix": "Package at",
      "onEstimate": "On estimate",
      "repairTime": "Observed average repair time",
      "days": "days",
      "productNewPrice": "Indicative/retail price",
      "purchasedInThisStore": "Product purchased in this store",
      "loadError": "Pricing options could not be loaded.",
      "noStore": "No store available",
      "noOption": "No pricing option is available for this store.",
      "missingKeyAccountClientNumber": "Missing client no."
    },
    "summary": {
      "progress": "Progress",
      "progressValue": "Step {current} of {total}",
      "folder": "Folder",
      "noFolder": "No folder created",
      "creationInProgress": "Repair file in creation",
      "productSection": "Selected product",
      "noProduct": "Select a product to create the draft repair file.",
      "manufacturer": "Brand",
      "category": "Range",
      "subCategory": "Sub-range",
      "product": "Product",
      "serialNumber": "Serial no",
      "breakdownSection": "Breakdown reason",
      "breakdown": "Breakdown description",
      "breakdownType": "Broken elements",
      "guaranteeSection": "Coverage",
      "guarantee": "Coverage",
      "underGuarantee": "Under guarantee",
      "outGuarantee": "Out of guarantee",
      "pricingSection": "Pricing",
      "package": "Package",
      "amount": "Amount",
      "delay": "Average delay",
      "days": "{count} days",
      "clientInfoSection": "Customer information",
      "company": "Company",
      "name": "Last name / first name",
      "contact": "Contact"
    },
    "guarantee": {
      "title": "Guarantee source",
      "serialSubtitle": "Search serial number",
      "serialPrerequisite": "Enter a valid serial number to continue guarantee evaluation.",
      "serialExampleOne": "The serial number is usually located on the product nameplate.",
      "serialExampleTwo": "Enter the full serial number to continue guarantee evaluation.",
      "serialFormatError": "Serial number must contain {count} character(s).",
      "serialNoData": "No matching serial number",
      "nameplateAlt": "Product nameplate",
      "workflowTitle": "Evaluate guarantee",
      "workflowSubtitle": "Follow the store workflow: serial number, purchase date, extension, then forced support if needed.",
      "inventoryMatch": "This product exists in your park. We will use the recorded invoice, nameplate, serial number, store, and network.",
      "noInventoryMatch": "No park product was found for this operating center and product. Store-level guarantee comparison will be used.",
      "sourceTitle": "Data source",
      "sourceInventory": "Product found in inventory",
      "sourceComparison": "Eligible store comparison",
      "invoice": "Customer invoice",
      "evidence": "Evidence",
      "available": "Available",
      "affectedProducts": "Evaluated items",
      "commercialDuration": "Commercial duration",
      "pendingComparison": "Calculated server-side",
      "days": "{count} days",
      "serialStep": "1. Serial number",
      "serialHelp": "Enter or verify the serial number. If the product exists in inventory, the recorded value is used.",
      "purchaseStep": "2. Purchase date",
      "purchaseHelp": "Commercial guarantee is calculated from the strongest retained store guarantee.",
      "purchaseEmpty": "Enter a purchase date to calculate coverage.",
      "commercialExpired": "Commercial guarantee is expired. Enter an extension if one exists.",
      "unknownPurchaseDate": "I cannot find the purchase date",
      "purchaseProof": "Purchase-date proof",
      "proofLater": "Proof upload will be available with key-account proof actions.",
      "extensionStep": "3. Guarantee extension",
      "extensionHelp": "Enter the extension end date provided by the customer.",
      "extensionEmpty": "Enter an extension date to calculate coverage.",
      "extensionExpired": "The extension is expired.",
      "extensionProof": "Guarantee-extension proof",
      "forceProof": "Forced support proof",
      "asbestosProof": "Asbestos proof",
      "uploadFromDesktop": "From computer",
      "uploadViaMobile": "Via mobile",
      "uploadedProof": "Document added",
      "inheritedProof": "Inventory document",
      "removeProof": "Remove document",
      "mobileUploadTitle": "Add document via mobile",
      "mobileUploadHelp": "Scan this QR code with a mobile device, upload the document, then confirm here once it is sent.",
      "mobileUploadConfirm": "Confirm upload",
      "mobileUploadMissing": "No document received yet. Upload it from the mobile device, then try again.",
      "withoutExtension": "Without extension",
      "successTitle": "Under guarantee",
      "warningTitle": "Out of guarantee",
      "guaranteeTime": "Guarantee duration",
      "guaranteeTimeRemaining": "Remaining time",
      "today": "Today",
      "noDay": "0 day",
      "remainingDays": "Covered for {count} more day(s).",
      "lastDay": "Last guarantee day.",
      "noCoverageTitle": "No valid coverage?",
      "noCoverageHelp": "You can force support with a reason or continue out of guarantee.",
      "forceAction": "Force support",
      "noGuaranteeAction": "Declare out of guarantee",
      "serialNumber": "Serial number",
      "serialNumberNotFoundForProlongation": "Unknown serial number for guarantee prolongation",
      "buyDate": "Purchase date",
      "extensionDate": "Guarantee extension end date",
      "forceDescription": "Forced support reason",
      "results": {
        "serialCovered": "Inventory guarantee validated",
        "commercialCovered": "Commercial guarantee",
        "extensionCovered": "Guarantee extension",
        "forcedCovered": "Forced support",
        "outGuarantee": "Out of guarantee"
      },
      "forceModal": {
        "title": "Force support under guarantee",
        "message": "The system indicates theoretical support, but the distributor can still force support under guarantee. Clearly explain the reason to the manufacturer / repairer so they can decide whether the support is relevant.",
        "reasonLabel": "Why should the support be under guarantee?",
        "reasonPlaceholder": "Example: this machine was repaired by the manufacturer 3 months ago and is therefore under guarantee.",
        "cancel": "Cancel",
        "confirm": "Confirm reason"
      },
      "exclusionModal": {
        "title": "Support exclusions for this product"
      },
      "types": {
        "commercial": "Commercial guarantee",
        "serial": "Serial number guarantee",
        "extension": "Guarantee extension",
        "force": "Force guarantee",
        "none": "Out of guarantee"
      }
    }
  },
  "guaranteeProofUpload": {
    "title": "Upload the proof",
    "subtitle": "Upload the proof from your mobile device.",
    "dropzoneTitle": "Drop the document",
    "acceptedFormats": "PDF, JPG, PNG",
    "hint": "After uploading, return to your computer to confirm.",
    "takePhoto": "Take a photo",
    "removeFile": "Remove document",
    "submit": "Send document",
    "successTitle": "Document sent",
    "successMessage": "You can return to your computer and confirm the upload.",
    "invalidTitle": "Expired or invalid link",
    "invalidMessage": "Request a new QR code from the repair file."
  },
  "additionalAttachmentUpload": {
    "title": "Add an attachment",
    "subtitle": "Upload the document from your mobile device.",
    "namePlaceholder": "File name",
    "dropzoneTitle": "Drop the document",
    "acceptedFormats": "PDF, JPG, PNG",
    "hint": "After uploading, return to your computer to confirm.",
    "takePhoto": "Take a photo",
    "removeFile": "Remove document",
    "submit": "Send document",
    "successTitle": "Document sent",
    "successMessage": "You can return to your computer and confirm the upload.",
    "invalidTitle": "Expired or invalid link",
    "invalidMessage": "Request a new QR code from the repair file."
  },
  "productRequestUpload": {
    "title": "Add a photo",
    "subtitle": "Add the nameplate photo from your phone.",
    "dropzoneTitle": "Drop the photo",
    "acceptedFormats": "JPG, JPEG, PNG",
    "hint": "Nameplate photo. If there is no nameplate, add a photo of the full product.",
    "takePhoto": "Take a photo",
    "removeFile": "Remove photo",
    "submit": "Send photo",
    "successTitle": "Photo sent",
    "successMessage": "You can return to your computer to complete the request.",
    "invalidTitle": "Expired or invalid link",
    "invalidMessage": "Generate a new QR code from the request."
  },
  "detail": {
    "title": "Repair file detail",
    "internalCommandNumber": "No. {reference}",
    "resume": "Resume repair file",
    "message": {
      "draft": "This repair file is a draft",
      "deleted": "This repair file has been deleted",
      "notFound": "Repair file not found"
    },
    "titles": {
      "summary": "Summary",
      "progression": "Progression",
      "pricing": "Client pricing (excl. tax)",
      "contact": "Contact"
    },
    "alt": {
      "productImage": "Product image"
    },
    "tabs": {
      "attachments": "Attachments",
      "contact": "Contact",
      "pricing": "Detailed pricing",
      "transport": "Round-trip addresses",
      "support": "Support",
      "prospectFlow": "Preliminary support request"
    },
    "fields": {
      "serialNumber": "Serial",
      "description": "Description",
      "lastname": "Contact name",
      "email": "Email",
      "phoneNumber": "Phone",
      "worksiteCode": "Specific code",
      "clientCode": "Client code",
      "support": "Initially requested support",
      "gestion": "Repair location",
      "underGuarantee": "Under guarantee",
      "outGuarantee": "Out of guarantee",
      "company": "Company",
      "store": "Store",
      "address": "Address",
      "operatingCenter": "Operating center",
      "transportType": "Transport type",
      "trackingNumber": "Tracking number",
      "breakdown": "Breakdown description",
      "breakdownType": "Breakdown type",
      "mode": "Mode",
      "element": "Affected elements",
      "guarantee": "Initial guarantee",
      "day": "{count} day",
      "days": "{count} days"
    },
    "pricingStatus": {
      "packageValidated": "Package validated by the customer",
      "estimateToIntegrate": "Estimate to integrate",
      "waitingCustomerDecision": "Waiting for customer decision on proposed options",
      "estimateValidated": "Estimate validated by the customer"
    },
    "status": {
      "inProgress": "Repair file in progress",
      "takeoverByCustomer": "Customer takeover"
    },
    "productEndStatus": {
      "PRODUCT_REPAIRED": "Machine repair",
      "PRODUCT_REPLACED_STANDARD": "Standard product replacement",
      "PRODUCT_REPLACED_SUPERIOR": "Superior product replacement",
      "PRODUCT_CREDIT": "Credit note handling",
      "PRODUCT_RECYCLED": "No repair: recycling",
      "PRODUCT_RETURN_DISASSEMBLED": "No repair: disassembled machine return",
      "PROSPECT_REPAIR_WITH_GUARANTEE": "Prior request: machine repair under warranty",
      "PROSPECT_REPAIR_WITHOUT_GUARANTEE": "Prior request: machine repair out of warranty",
      "PROSPECT_CREDIT_OR_REFUND": "Prior request: credit note",
      "PROSPECT_REPLACEMENT": "Prior request: exchange",
      "PROSPECT_REJECT": "Prior request: no support",
      "PROSPECT_OTHER": "Prior request: other",
      "DEFAULT": "Repair file without customer handover"
    },
    "productType": {
      "MACHINE": "Machine",
      "BATTERY": "Battery",
      "CHARGER": "Charger",
      "PRODUCT": "Product",
      "ACCESSORY_ONE": "Accessory 1",
      "ACCESSORY_TWO": "Accessory 2",
      "BRIEFCASE": "Case",
      "PREMIUM_CONSUMABLE": "Premium consumable",
      "PPE": "Personal protective equipment",
      "EQUIPMENT": "Equipment",
      "SUB_PRODUCT": "Sub-product",
      "PALLET": "Pallet"
    },
    "statusDisplay": {
      "IN_CREATION": "In creation",
      "TRANSPORT_GO": "Outbound transport",
      "RECEPTION_AT_REPAIRER": "Repairer reception",
      "DIAGNOSTIC_MANUFACTURER_RECEIVED": "Diagnostic received",
      "DIAGNOSTIC_MANUFACTURER_PROCESSED": "Diagnostic processed",
      "ESTIMATE_SENT_TO_CUSTOMER": "Customer decision - estimate",
      "ESTIMATE_CUSTOMER_DECISION_SENT_TO_REPAIRER": "Repairer estimate approved",
      "IN_REPARATION": "Repair",
      "SENT_BACK_BY_REPAIRER": "Return transport",
      "RECEIPT_AT_STORE": "Store reception",
      "SENT_AVAILABLE_TO_CUSTOMER": "Waiting collection",
      "TAKEOVER_BY_CUSTOMER": "Closed",
      "NETWORK_BILLING": "Billing",
      "FINISHED": "Finished"
    },
    "transportModality": {
      "TRANSPORTER": "Transporter",
      "DISTRIBUTOR_DROP_OFF": "Product drop-off at a distributor"
    },
    "repairLocation": {
      "externalRepairer": "External repairer",
      "storeWorkshop": "Store workshop",
      "customerWorkshop": "Customer workshop"
    },
    "attachment": {
      "add": "Add",
      "name": "File name",
      "namePlaceholder": "File name",
      "file": "File",
      "modalTitle": "Add attachment",
      "modalSubtitle": "Add a file from this computer or generate a QR code to add it from a mobile device.",
      "acceptedFormats": "Accepted formats: PDF, JPG, PNG, JPEG",
      "uploadViaMobile": "Add with QR code",
      "mobileUploadSubtitle": "Scan this QR code with a mobile device to add the attachment.",
      "mobileUploadConfirm": "I added the document",
      "mobileUploadMissing": "No document has been added with QR code yet.",
      "customerSatisfaction": "Customer satisfaction",
      "permissionDenied": "You do not have permission to view repair file attachments.",
      "printPermissionDenied": "You do not have permission to download repair file attachments.",
      "packageEstimate": "Package estimate",
      "packingSlip": "Transport order",
      "repairOrder": "Repair order",
      "afterSaleService": "After-sale service",
      "purchaseProof": "Customer invoice",
      "warrantyExtension": "Warranty extension",
      "forceWarrantyExtension": "Forced warranty",
      "asbestos": "Asbestos declaration",
      "batteryLabel": "Danger label",
      "boomerangWarrantyExtension": "BOOMERANG warranty extension",
      "deliveryNote": "Delivery note",
      "transporterDocumentForRepairer": "Transporter document for repairer",
      "manufacturerAttachment": "Manufacturer attachment",
      "prospectOrderWaiting": "Prospect waiting order",
      "prospectPicture": "Additional picture",
      "prospectDocument": "Additional document"
    },
    "comment": {
      "title": "Comments",
      "placeholder": "Add a comment",
      "visibilityStore": "Make visible on shared comments",
      "send": "Send",
      "infoAlert": "The Boomerang team is not alerted of your comments. To contact us, press Chat (green bubble at the bottom right).",
      "invisibleToStore": "Invisible by Store Team",
      "type": {
        "STORE": "Store Team",
        "KEY_ACCOUNT": "Client User",
        "ADMIN": "BOOMERANG Team",
        "EXTERNAL": "External",
        "REPAIRER": "Repairer"
      }
    },
    "contact": {
      "customer": "Customer",
      "store": "Store",
      "copySuccess": "Contact address copied.",
      "copyError": "Unable to copy contact address.",
      "storeFields": {
        "name": "Name",
        "address": "Address",
        "phone": "Phone number",
        "email": "Contact address"
      }
    },
    "pricing": {
      "distributorPackageCode": "Distributor package code",
      "manufacturerPackageCode": "Manufacturer package code",
      "clientRepairPrice": "Repair price",
      "transportPrice": "Transport price",
      "managementPrice": "Management price",
      "repairFund": "Repair fund",
      "totalClientPrice": "Total client price (excl. tax)",
      "customerEndCost": "Total client price (excl. tax)",
      "packageCode": "Manufacturer package code",
      "packageSupportCost": "Support price (excl. tax)",
      "clientLabel": "Client",
      "estimateValidateByCustomer": "Offer approved by client",
      "estimateValidateTakeoverByCustomer": "Final client offer",
      "comment": "Comments:",
      "optionStatus": {
        "PRODUCT_REPAIRED": "Machine repair",
        "PRODUCT_REPLACED_STANDARD": "Standard product replacement",
        "PRODUCT_REPLACED_SUPERIOR": "Superior product replacement",
        "PRODUCT_CREDIT": "Credit note handling",
        "PRODUCT_RECYCLED": "No repair: recycling",
        "PRODUCT_RETURN_DISASSEMBLED": "No repair: disassembled machine return",
        "PROSPECT_REPAIR_WITH_GUARANTEE": "Prior request: machine repair under warranty",
        "PROSPECT_REPAIR_WITHOUT_GUARANTEE": "Prior request: machine repair out of warranty",
        "PROSPECT_CREDIT_OR_REFUND": "Prior request: credit note",
        "PROSPECT_REPLACEMENT": "Prior request: exchange",
        "PROSPECT_REJECT": "Prior request: no support",
        "PROSPECT_OTHER": "Prior request: other"
      }
    },
    "pricingType": {
      "package": "Package",
      "estimate": "Estimate"
    },
    "transport": {
      "packageWeight": "Package weight",
      "pallet": "Transport with pallet",
      "outbound": "Outbound transport",
      "outboundDepartureAddress": "OUTBOUND - DEPARTURE ADDRESS",
      "outboundDestinationAddress": "OUTBOUND - DESTINATION ADDRESS",
      "return": "Return transport",
      "returnRepairerAddress": "RETURN - RETURN ADDRESS",
      "carrierContractLogin": "Carrier contract login",
      "addressName": "Address name",
      "address": "Address",
      "city": "City",
      "transportArrangement": "Transport arrangement",
      "transporter": "Carrier",
      "finalizationDate": "Repair file finalization date",
      "pickupScheduled": "Pickup scheduled",
      "trackingNumber": "Tracking number",
      "type": {
        "IMMEDIATE_TRANSPORTER": "Immediate carrier transport",
        "CUSTOMER_SERVICE_TRANSPORTER": "Transport arranged by repairer customer service",
        "WITHOUT_TRANSPORTER": "Transport arranged independently"
      }
    }
  },
  "table": {
    "reference": "Repair file",
    "store": "Store name",
    "company": "Company",
    "manufacturer": "Brand",
    "product": "Product",
    "rental": "Rental",
    "status": "Status",
    "time": "Time",
    "date": "Date",
    "modality": "Handled by",
    "day": "{count} day",
    "days": "{count} days"
  },
  "filters": {
    "needAction": "Repair files requiring action",
    "inProgress": "In-progress repair files only",
    "rental": "With rental file only",
    "creationDate": "Creation date",
    "manufacturer": "Select manufacturer",
    "status": "Select status",
    "store": "Select store",
    "repairCenter": "Select repair center",
    "modality": "Select modality"
  },
  "statusMacro": {
    "IN_CREATION": "In creation",
    "IN_CREATION_ESTIMATE": "In creation - estimate",
    "IN_CREATION_PROSPECT": "In creation - request",
    "TRANSPORT_GO": "Outbound transport",
    "RECEPTION_AT_REPAIRER": "Repairer reception",
    "DIAGNOSTIC_MANUFACTURER_RECEIVED": "Diagnostic received",
    "DIAGNOSTIC_MANUFACTURER_PROCESSED": "Diagnostic processed",
    "ESTIMATE_SENT_TO_CUSTOMER": "Customer decision - estimate",
    "ESTIMATE_CUSTOMER_DECISION_SENT_TO_REPAIRER": "Repairer estimate approved",
    "IN_REPARATION": "Repair",
    "SENT_BACK_BY_REPAIRER": "Return transport",
    "RECEIPT_AT_STORE": "Store reception",
    "SENT_AVAILABLE_TO_CUSTOMER": "Waiting collection",
    "TAKEOVER_BY_CUSTOMER": "Closed",
    "NETWORK_BILLING": "Billing",
    "FINISHED": "Finished",
    "ABORT_BY_CUSTOMER": "Abandoned by customer"
  },
  "modality": {
    "TRANSPORTER": "Transporter",
    "DISTRIBUTOR_DROP_OFF": "Product drop-off at a distributor"
  }
}
